import { GlIcon } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import TooltipOnTruncate from '../../../vue_shared/components/tooltip_on_truncate/tooltip_on_truncate.vue?vue3';
export default {
    name: 'SidebarSeverity',
    components: {
        GlIcon,
        TooltipOnTruncate
    },
    props: {
        severity: {
            type: Object,
            required: true,
            validator (severity) {
                const { value, label, icon } = severity;
                return value && label && icon;
            }
        },
        iconSize: {
            type: Number,
            required: false,
            default: 12
        },
        iconOnly: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
